import theme from '@styles/theme';
export default {
  section: (background: string | null = null) => ({
    height: ['520px', '520px', '1024px', '1024px', '46.875vw'],
    bg: theme.rawColors.neutralWhite,
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    backgroundImage: background ? `url(${background})` : null,
    backgroundSize: 'cover'
  })
};